import { CourseRole } from '../../../db/types';
import i18n, { i18nNS } from '../../../i18n';

export function translateCourseRole(courseRole: CourseRole) {
  switch (courseRole) {
    case CourseRole.ADMIN:
      return i18n.t('course_admin', { ns: i18nNS.COURSE });
    case CourseRole.INSTRUCTOR:
      return i18n.t('course_instructor', { ns: i18nNS.COURSE });
    default:
      return courseRole;
  }
}
